var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClaim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    transform: "translate(1431 292)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1431 -292)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1429.233 290.233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.883,48.583H20.317V2.65H45.05l8.833,8.833Z",
    fill: "#87ced9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.567,37.294a10.153,10.153,0,0,0-7.95-9.911l2.65-5.3h-7.95v26.5H34.229l-.663-.883Z",
    fill: "#73bec9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.05,2.65v8.833h8.833Z",
    fill: "#e8594a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,53.883H4.637A1.988,1.988,0,0,1,2.65,51.9h0a1.987,1.987,0,0,1,.4-1.193l2.252-3V37.294a10.153,10.153,0,0,1,7.95-9.911h8.833a10.153,10.153,0,0,1,7.95,9.911V47.7l2.252,3a1.987,1.987,0,0,1,.4,1.192h0A1.988,1.988,0,0,1,30.7,53.883Z",
    fill: "#fdbb3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.033,47.7V37.294a10.119,10.119,0,0,0-1.5-5.3C21.772,42.54,10.112,48.285,2.868,50.986a1.985,1.985,0,0,0,1.769,2.9H30.7a1.988,1.988,0,0,0,1.59-3.18Z",
    fill: "#fdaf33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.083,27.383H13.25l-2.65-5.3H24.733Z",
    fill: "#f7b016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.992,39.75h-2.65a1.325,1.325,0,1,1,0-2.65H21.2V35.333H18.55V33.567H16.783v1.767h-.442a3.092,3.092,0,1,0,0,6.183h2.65a1.325,1.325,0,0,1,0,2.65H14.133v1.767h2.65V47.7H18.55V45.933h.442a3.092,3.092,0,1,0,0-6.183Z",
    fill: "#e8594a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.85,8.833v4.874a5.3,5.3,0,0,0,2.671,4.6l3.513,2.007,3.513-2.007a5.3,5.3,0,0,0,2.67-4.6V8.833h0a7.95,7.95,0,0,1-4.77-1.59l-1.413-1.06L28.62,7.243a7.95,7.95,0,0,1-4.77,1.59Z",
    fill: "#4398d1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.767,
    height: 1.767,
    transform: "translate(29.15 9.717)",
    fill: "#5ea9db"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.767,
    height: 1.767,
    transform: "translate(29.15 15.017)",
    fill: "#5ea9db"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.767,
    height: 1.767,
    transform: "translate(26.5 12.293)",
    fill: "#5ea9db"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.767,
    height: 1.767,
    transform: "translate(31.8 12.367)",
    fill: "#5ea9db"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.083,
    height: 1.767,
    transform: "translate(27.383 23.85)",
    fill: "#73bec9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.833,
    height: 1.767,
    transform: "translate(30.917 28.267)",
    fill: "#73bec9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.95,
    height: 1.767,
    transform: "translate(41.517 28.267)",
    fill: "#73bec9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.9,
    height: 1.767,
    transform: "translate(33.567 32.683)",
    fill: "#73bec9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.717,
    height: 1.767,
    transform: "translate(33.567 37.1)",
    fill: "#73bec9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.417,
    height: 1.767,
    transform: "translate(45.05 37.1)",
    fill: "#73bec9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.9,
    height: 1.767,
    transform: "translate(33.567 41.517)",
    fill: "#73bec9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.833,
    height: 1.767,
    transform: "translate(40.633 19.433)",
    fill: "#73bec9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.833,
    height: 1.767,
    transform: "translate(40.633 15.017)",
    fill: "#73bec9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.833,
    height: 1.767,
    transform: "translate(45.05 11.483)",
    fill: "#73bec9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.71,11.2c-.01-.028-.017-.056-.029-.083a.883.883,0,0,0-.177-.259L45.671,2.025a.883.883,0,0,0-.26-.177c-.026-.011-.052-.019-.079-.028a.846.846,0,0,0-.234-.046c-.014,0-.03-.008-.048-.008H20.317a.883.883,0,0,0-.883.883V19.433H21.2V3.533H44.167v7.95a.883.883,0,0,0,.883.883H53V47.7H34.45v1.767H53.883a.883.883,0,0,0,.883-.883v-37.1c0-.019-.01-.036-.011-.056A.835.835,0,0,0,54.71,11.2Zm-8.777-.6V4.782L51.751,10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.637,54.767H30.7a2.871,2.871,0,0,0,2.3-4.593l-2.076-2.767V37.294a10.953,10.953,0,0,0-7.565-10.472l2.177-4.344a.883.883,0,0,0-.8-1.278H10.6a.883.883,0,0,0-.791,1.278l2.172,4.344A10.953,10.953,0,0,0,4.417,37.294V47.406L2.341,50.173a2.871,2.871,0,0,0,2.3,4.593ZM23.3,22.967,21.537,26.5H13.8l-1.767-3.533ZM3.754,51.233l2.252-3a.883.883,0,0,0,.177-.53V37.294a9.212,9.212,0,0,1,7.166-9.028h8.635a9.212,9.212,0,0,1,7.166,9.028V47.7a.883.883,0,0,0,.177.53l2.253,3A1.1,1.1,0,0,1,30.7,53H4.637a1.1,1.1,0,0,1-.883-1.767Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.342,41.517h2.65a1.325,1.325,0,0,1,0,2.65H14.133v1.767h2.65V47.7H18.55V45.933h.442a3.092,3.092,0,1,0,0-6.183h-2.65a1.325,1.325,0,1,1,0-2.65H21.2V35.333H18.55V33.567H16.783v1.767h-.442a3.092,3.092,0,1,0,0,6.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.217,7.95a7.112,7.112,0,0,1-4.24-1.413l-1.413-1.06a.883.883,0,0,0-1.06,0L28.09,6.537A7.112,7.112,0,0,1,23.85,7.95a.883.883,0,0,0-.883.883v4.874a6.2,6.2,0,0,0,3.116,5.372l3.509,2a.883.883,0,0,0,.876,0l3.517-2A6.2,6.2,0,0,0,37.1,13.708V8.833A.883.883,0,0,0,36.217,7.95Zm-.883,5.758a4.425,4.425,0,0,1-2.225,3.835L30.033,19.3l-3.075-1.757a4.426,4.426,0,0,1-2.225-3.835V9.672A8.9,8.9,0,0,0,29.15,7.95l.883-.662.883.662a8.9,8.9,0,0,0,4.417,1.722Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.767,
    height: 1.767,
    transform: "translate(29.15 9.717)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.767,
    height: 1.767,
    transform: "translate(29.15 15.017)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.767,
    height: 1.767,
    transform: "translate(26.5 12.293)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.767,
    height: 1.767,
    transform: "translate(31.8 12.367)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.083,
    height: 1.767,
    transform: "translate(27.383 23.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.833,
    height: 1.767,
    transform: "translate(30.917 28.267)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.95,
    height: 1.767,
    transform: "translate(41.517 28.267)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.9,
    height: 1.767,
    transform: "translate(33.567 32.683)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.717,
    height: 1.767,
    transform: "translate(33.567 37.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.417,
    height: 1.767,
    transform: "translate(45.05 37.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.9,
    height: 1.767,
    transform: "translate(33.567 41.517)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.833,
    height: 1.767,
    transform: "translate(40.633 19.433)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.833,
    height: 1.767,
    transform: "translate(40.633 15.017)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaim);
export default __webpack_public_path__ + "static/media/claim.0dea100e207479ae306b6e460ef01010.svg";
export { ForwardRef as ReactComponent };